import * as yup from "yup";
import { format, isBefore } from "date-fns";

export const marcarActaComoImpresaSchema = yup.object().shape({
  fecha_impresion: yup
    .string()
    .required("La fecha de impresion del acta es requerida")
    .transform((value, originalValue) => {
      return originalValue === "" ? null : format(value, "yyyy-MM-dd HH:mm:ss");
    })
    .test(
      "mayor_que_hoy",
      "La fecha de impresión no puede ser mayor que ahora",
      (value, context) => {
        // console.log(format(value, "yyyy-MM-dd HH:mm:ss"));
        // console.log(format(new Date(), "yyyy-MM-dd HH:mm:ss"));
        return isBefore(
          format(value, "yyyy-MM-dd HH:mm:ss"),
          format(new Date(), "yyyy-MM-dd HH:mm:ss")
        );
      }
    ),
});
